import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { DownloadFileTypeResponse } from '@/repositories/generated';

const response: DownloadFileTypeResponse[] = [
  { code: 'COMPREHENSIVE_TRANSFER', name: '加盟店精算（総合振込）' },
  { code: 'ACCOUNT_TRANSFER', name: '加盟店精算（口座振替）' },
  { code: 'SETTLEMENT_VI', name: '加盟店精算（イシュア別精算データ）' },
  { code: 'RECONSILE-FILE-CREATE', name: '売上データ還元ファイル' },
  { code: 'MONTHLY_RECONSILE_FILE_CREATE', name: '売上データ還元ファイル（月次）' },
  { code: 'BANKPAY_RECONCILE', name: 'リコンサイル（Bank Pay）' },
  { code: 'DETECTION', name: '不正検知' },
  { code: 'APP_USER_CSV', name: 'ウォレットユーザ一覧' },
  { code: 'TRANSACTION_HISTORY_CSV', name: '取引履歴一覧' },
  { code: 'QR_PRINT_REQUEST', name: 'QR配送依頼' },
  { code: 'DGFT_RECONCILE', name: 'リコンサイル（DGフィナンシャルテクノロジー）' },
  { code: 'GMO_RECONCILE', name: 'リコンサイル（PSP-GMO）' },
  { code: 'WS_POINT_CHANGE', name: 'ポイント付与連携' },
  { code: 'WS_POINT_CHANGE_UNREGISTERED', name: 'ポイント付与連携（管理外店舗）' },
  { code: 'WS_POINT_CHANGE_ERROR', name: 'ポイント付与連携（エラー）' },
  { code: 'EXPIRY_DATEWISE_BALANCE_DATA', name: '有効期限別残高' },
];

export const autocompleteFileDownloadType = http.get(
  createMockEndpoint('/autocomplete/download_file_type'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
